//@ts-nocheck
import React, { useEffect, useState, useRef, memo, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormContext } from "../../../context/FormContext/FormContext";
import { Form } from "antd";
import FormDevInfo from "../FormComplete/FormDevInfo/FormDevInfo";
import FormTab from "../FormTab/FormTab";
import FormAttachments from "../FormAttachments/FormAttachments";
import MessageHistoryTable from "../MessageHistoryTable/MessageHistoryTable";
import FormNotAvailable from "../FormComplete/FormNotAvailable/FormNotAvailable";
import { Tabs } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { Button, Spin, Message, Modal } from "../../BP2Components";
import IntlMessages from "../../../util/IntlMessages";
import { useMessageItem } from "../../../context/MessageItemContext/MessageItemContext";
const { TabPane } = Tabs;
import { useReactToPrint } from "react-to-print";
import { PRINT_STYLES, renderTemplate } from "../GeneralScripts";
import FormError from "../FormError/FormError";
import projectConfig from "../../../projectConfig.json";
import BusinessCard from "../../Widgets/BusinessCardWidget/BusinessCard";
import { CallManager } from "../../CallManager";
import { prepareBlankRequiredFields, renderField, shouldHideTab } from "../FormTab/FormTabUtils";
import { useIntl } from "react-intl";
import alertIcon from "../../../assets/icons/alert-triangle.svg";

import "./FormBody.less";
import { useFastActionsContext } from "../../Widgets/InfiniteListWidget/FastActionsContext/FastActionContext";
import { resetChangeFlag } from "../../../appRedux/actions/DevForm";

// Ts-ignore is used to ignore typescript errors in Tabs, that's a Antd fault

interface IFormBodyProps {
   attachmentLabelText?: string;
   areOnlyRequiredFieldsVisible?: boolean;
   label?: string;
}

const FormBody = memo(
   ({ attachmentLabelText, areOnlyRequiredFieldsVisible, label }: IFormBodyProps) => {
      const [isOpen, setIsOpen] = useState<boolean>(false);
      const [isOpenDevForm, setIsOpenDevForm] = useState<boolean>(false);
      const [pendingTabKey, setPendingTabKey] = useState<string | null>(null);
      const [missingFields, setMissingFields] = useState();
      const isAnyChange = useSelector((state) => state.devForm?.isAnyChange);
      const dispatch = useDispatch();
      const {
         formData,
         form,
         formUuid,
         formId,
         isMessageForm,
         isLoading,
         template,
         isSubmitVisible,
         printable,
         hideAttachments,
         handleFormSubmit,
         isAnyFieldLoading,
         responseData,
         pendingRequests,
         fieldsInfo,
      } = useFormContext();

      const {
         anchorTab,
         setAnchorTab,
         currentProcessStep,
         instanceId,
         triggerRequiredFieldsModal,
         setTriggerRequiredFieldsModal,
         pendingAction,
         setPendingAction,
      } = useMessageItem();

      const { tabsVisibility, setIsFormLoading, setHasRequiredFields } = useFastActionsContext();

      const formStructure = formData?.forms_data;
      const [activeTabKey, setActiveTabKey] = useState<string>(
         () => formStructure?.tab?.[0]?.id || "",
      );
      const shouldHideTabLocal = (tab) => {
         return shouldHideTab(tab, areOnlyRequiredFieldsVisible, fieldsInfo, form);
      };

      // Check if any tab has visible required fields
      const hasAnyRequiredFields = useMemo(() => {
         if (!areOnlyRequiredFieldsVisible || !formStructure?.tab) return true;
         return formStructure.tab.some((tab) => !shouldHideTabLocal(tab));
      }, [areOnlyRequiredFieldsVisible, formStructure?.tab, tabsVisibility]);

      useEffect(() => {
         if (!areOnlyRequiredFieldsVisible) return;
         setHasRequiredFields(hasAnyRequiredFields);
      }, [hasAnyRequiredFields, areOnlyRequiredFieldsVisible]);

      const isFormAvailable = !formStructure?.form_available_for?.includes("30008054");

      const messageHistory = useSelector(({ formsv2 }: any) => formsv2.messageHistory);
      const printRef = useRef(null);
      const formTabRef = useRef(null);
      const showAttachments = currentProcessStep?.configuration?.overall?.hideAttachments === false;
      const intl = useIntl();

      const currentActiveTabKey = anchorTab
         ? anchorTab
         : activeTabKey
           ? activeTabKey
           : formStructure?.tab?.[0].id;

      useEffect(() => {
         if (formStructure && template && form) {
            setTimeout(() => {
               renderTemplate(formId, template, form, hideEmptyElementsInTemplate());
            }, 2000);
         }
      }, [formStructure, template, form]);

      useEffect(() => {
         if (isAnyFieldLoading) {
            Message.loading();
         } else {
            Message.destroy();
         }
      }, [isAnyFieldLoading]);

      const handleChangeTabBarStyle = (structure) => {
         if (structure.tab[0].name === "" && showAttachments) {
            return { display: "none" };
         }
      };

      const changeTabHandle = (tabKey) => {
         if (!!window.devLogged && currentActiveTabKey !== tabKey && isAnyChange) {
            setIsOpenDevForm(true);
            setPendingTabKey(tabKey);
         } else {
            changeTab(tabKey);
         }
      };

      const changeTab = (tabKey) => {
         if (isOpenDevForm) {
            setIsOpenDevForm(false);
            dispatch(resetChangeFlag());
         }
         setActiveTabKey(tabKey);
         setAnchorTab(null);
      };

      const hideEmptyElementsInTemplate = () => {
         // "[0]" becouse templates are handling only first tab
         if (formData?.forms_data?.tab[0]?.elements) {
            // get all the empty fields
            const emptyFields = Object?.values(formData?.forms_data?.tab[0]?.elements)?.filter(
               //@ts-ignore
               (element) => element?.value === "",
            );

            // this regex find "showhide" in string. Support want us to delete from DOM elements that have empty vale and has "showhide" in className
            const regex = /showhide/;

            // filter all the empty fields, by parameter that support want us to hide
            // TODO: they need to create that parameter, and we need to filter it by that parameter
            const emptyFieldsToHide = emptyFields?.filter(
               // @ts-ignore
               (field) => regex.test(field?.tech_name),
            );

            // create list of classNames to hide
            const listOfTechnamesToHide = emptyFieldsToHide?.map(
               // @ts-ignore
               (field) => `${field?.tech_name}`,
            );

            return listOfTechnamesToHide;
         }
      };

      const handlePrint = useReactToPrint({
         content: () => printRef.current,
         removeAfterPrint: true,
         // This makes sure that template is printed with proper styling
         pageStyle: PRINT_STYLES,
      });

      useEffect(() => {
         const handleLoadDev = () => {
            requestAnimationFrame(() => {
               if (window.devLogged) {
                  window.dev();
               }
            });
         };

         if (document.readyState === "complete") {
            handleLoadDev();
         } else {
            window.addEventListener("load", handleLoadDev);
            return () => window.removeEventListener("load", handleLoadDev);
         }
      }, [activeTabKey]);

      const getTabClassName = () => {
         /* `${
         // old version: formStructure.tab?.length <= 1 && !showAttachments && !messageHistory?.length
         // new version: formStructure.tab?.length <= 1 || (!showAttachments && !messageHistory?.length)
         // we have problem with collecting testing data. for now, we test it on bp2 qa(visible) task form, and cp pre prod(hidden) 
         // form: "13077" (moje konto -> zmień dane)
         // if you have new case, write it down, and include above cases in your testing scenario
         formStructure.tab?.length <= 1 || (!showAttachments && !messageHistory?.length)
            ? "tabs-topbar-hidden"
            : ""
      }` */

         // I dont understand this comment ^

         let classNameString = "";
         if (formStructure.tab?.length <= 1 && !showAttachments && !messageHistory?.length) {
            classNameString = "tabs-topbar-hidden";
         }
         if (formStructure.tab.length === 1 && projectConfig?.hideWhenBasicTabPlusAttachments) {
            classNameString = "tabs-topbar-hidden";
         }
         return classNameString;
      };

      const activeTabElements = useMemo(() => {
         const tabs = formStructure?.tab;
         if (!Array.isArray(tabs)) return null;

         const currentTab = tabs.find((tab) => tab.id === activeTabKey);
         return currentTab?.elements ?? null;
      }, [formStructure?.tab, activeTabKey]);

      useEffect(() => {
         if (!triggerRequiredFieldsModal) return;
         const elements =
            activeTabElements != null
               ? Object.values(activeTabElements)
               : (formStructure?.tab?.flatMap((t) => Object.values(t.elements ?? {})) ?? []);
         if (!elements.length) return;
         const result = prepareBlankRequiredFields(fieldsInfo, elements, intl);

         if (result && result.length > 0) {
            const values = form.getFieldsValue();

            const resultWithoutFilled = result.filter((el) => {
               const value = values[el.tech_name];
               return value === "" || value === null || value === undefined;
            });

            if (resultWithoutFilled.length > 0) {
               setMissingFields(resultWithoutFilled);
               setIsOpen(true);
            }
         }
      }, [triggerRequiredFieldsModal]);

      useEffect(() => {
         if (areOnlyRequiredFieldsVisible) {
            setIsFormLoading(isLoading);
         }
      }, [isLoading]);

      return (
         <>
            <Form
               className="form-complete"
               id="form"
               labelCol={{ span: 8, style: { paddingLeft: 0 } }}
               wrapperCol={{ style: { width: "100%" } }}
               layout="horizontal"
            >
               <FormDevInfo
                  form={form}
                  formId={formId || responseData?.forms_data?.UIF_ID}
                  formUuid={formUuid}
                  instanceId={(isMessageForm && instanceId) || 0}
                  recordId={formStructure?.dataModel?.id}
               />
               {formStructure && isFormAvailable && formStructure?.tab ? (
                  <>
                     {formData?.forms_data.display_type == "BUSINESS_LISTING" ? (
                        <BusinessCard tabs={formStructure?.tab} />
                     ) : formData?.forms_data.display_type == "PHONE_CALL" &&
                       projectConfig.callManagerDisplay ? (
                        <CallManager
                           tabs={formStructure?.tab}
                           parentId={formStructure?.parent_id}
                        />
                     ) : (
                        <>
                           {/* @ts-ignore */}
                           <Tabs
                              tabBarStyle={handleChangeTabBarStyle(formStructure)}
                              activeKey={String(
                                 anchorTab
                                    ? anchorTab
                                    : activeTabKey
                                      ? activeTabKey
                                      : formStructure?.tab?.[0].id,
                              )}
                              onTabClick={changeTabHandle}
                              className={getTabClassName()}
                              style={{ display: !hasAnyRequiredFields ? "none" : "" }}
                           >
                              {formStructure?.tab
                                 .filter((tab) => !shouldHideTabLocal(tab))
                                 .map((tab) => (
                                    // @ts-ignore
                                    <TabPane
                                       tab={tab.name}
                                       key={String(tab.id)}
                                       className={`tab-pane-${tab.id}`}
                                       forceRender={true}
                                    >
                                       {projectConfig.formConfig.showCaseTitle && isMessageForm && (
                                          <div className="form-complete__title">
                                             {+formStructure.hide_title === 0 && (
                                                <h6>{formStructure.title}</h6>
                                             )}
                                          </div>
                                       )}
                                       <FormTab
                                          elements={Object.values(tab.elements)}
                                          //@ts-ignore
                                          initialData={null}
                                          areOnlyRequiredFieldsVisible={
                                             areOnlyRequiredFieldsVisible &&
                                             projectConfig.areFastActionsEnabled
                                          }
                                          ref={formTabRef}
                                          tab={tab}
                                          tabId={tab.id}
                                          currentActiveTabKey={currentActiveTabKey}
                                       />
                                       {template && (
                                          <>
                                             {(printable || currentProcessStep?.stepId) &&
                                                formStructure.print_hide !== "1" && (
                                                   <Button
                                                      onClick={handlePrint}
                                                      style={{
                                                         margin:
                                                            currentProcessStep?.stepId && "1rem",
                                                      }}
                                                      buttonType="primary"
                                                   >
                                                      <PrinterOutlined />
                                                      <IntlMessages id="forms.printTemplate" />
                                                   </Button>
                                                )}
                                             <section
                                                ref={printRef}
                                                id={`template-${formId}`}
                                                className={`template-in-form`}
                                             />
                                          </>
                                       )}
                                       {isSubmitVisible && formStructure?.hide_submit !== "1" && (
                                          <Button
                                             className="form-complete__button"
                                             htmlType="submit"
                                             buttonType="primary"
                                             onClick={handleFormSubmit}
                                             disabled={pendingRequests.current > 0}
                                          >
                                             {label?.trim()?.length ? (
                                                label
                                             ) : (
                                                <IntlMessages id="global.save" />
                                             )}
                                          </Button>
                                       )}
                                    </TabPane>
                                 ))}

                              {showAttachments && !areOnlyRequiredFieldsVisible && (
                                 // @ts-ignore
                                 <TabPane
                                    key={formStructure.tab.length}
                                    tab={
                                       !!attachmentLabelText?.length ? (
                                          <IntlMessages id={attachmentLabelText} />
                                       ) : (
                                          <IntlMessages id="form.attachments" />
                                       )
                                    }
                                 >
                                    <FormAttachments />
                                 </TabPane>
                              )}
                              {messageHistory?.length > 0 && (
                                 // @ts-ignore
                                 <TabPane
                                    key={formStructure.tab.length + 1}
                                    tab={<IntlMessages id="form.history" />}
                                 >
                                    <MessageHistoryTable messageHistory={messageHistory} />
                                 </TabPane>
                              )}
                           </Tabs>

                           {/* Hidden tabs - rendered but not visible to preserve field values */}
                           {formStructure?.tab
                              .filter((tab) => shouldHideTabLocal(tab))
                              .map((tab) => (
                                 <div key={`hidden-${tab.id}`} style={{ display: "none" }}>
                                    <FormTab
                                       elements={Object.values(tab.elements)}
                                       //@ts-ignore
                                       initialData={null}
                                       areOnlyRequiredFieldsVisible={areOnlyRequiredFieldsVisible}
                                       ref={formTabRef}
                                       tab={tab}
                                    />
                                 </div>
                              ))}

                           {!hasAnyRequiredFields && (
                              <div className="form-tab__no-required-fields">
                                 <IntlMessages id="form.noRequiredFields" />
                              </div>
                           )}
                        </>
                     )}
                  </>
               ) : isLoading ? (
                  <Spin className="spin-middle" />
               ) : formStructure && !isFormAvailable ? (
                  <FormNotAvailable formId={formId} />
               ) : (
                  <FormError />
               )}
            </Form>
            <Modal isOpen={isOpenDevForm}>
               <div className="dev-form-modal">
                  <span className="dev-form-modal__discard-text">
                     <IntlMessages id={"devForm.discardChanges"} />
                  </span>
                  <div className="dev-form-modal__buttons">
                     <Button
                        onClick={() => {
                           setIsOpenDevForm(false);
                        }}
                        buttonType="primary"
                     >
                        <IntlMessages id="global.cancel" />
                     </Button>
                     <Button onClick={() => changeTab(pendingTabKey)} buttonType="primary">
                        <IntlMessages id="global.changeTab" />
                     </Button>
                  </div>
               </div>
            </Modal>
            <Modal
               isOpen={
                  isOpen && (areOnlyRequiredFieldsVisible || !!projectConfig.withMissingFieldsPopUp)
               }
               width={window.innerWidth * 0.95}
               height={window.innerHeight * 0.95}
               bodyStyles={{ padding: "0.5rem" }}
               topBarStyles={{ borderBottom: "none" }}
               onCancel={() => {
                  setIsOpen(false);
                  setTriggerRequiredFieldsModal(false);
                  setPendingAction(null);
               }}
            >
               <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                     <img src={alertIcon} />
                     <span style={{ display: "block", textAlign: "center" }}>
                        <IntlMessages
                           id={"Należy poprawnie uzupełnić brakujące pola obowiązkowe"}
                        />
                     </span>
                  </div>
                  <div className="form-tab-in-modal">
                     {missingFields?.map((element) =>
                        formTabRef.current
                           ? renderField(element, formTabRef.current.getPropsForAllFields, true)
                           : null,
                     )}
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
                     <Button
                        style={{ borderRadius: "50px", minWidth: "10rem" }}
                        onClick={() => {
                           setIsOpen(false);
                           setTriggerRequiredFieldsModal(false);
                           if (pendingAction) {
                              pendingAction();
                           }
                        }}
                        buttonType="primary"
                     >
                        <IntlMessages id="global.save" />
                     </Button>
                  </div>
               </div>
            </Modal>
         </>
      );
   },
);

export default FormBody;
